var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCicd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 227,
    viewBox: "0 0 305 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_9702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.946 23.1534C169.923 23.1534 173.147 19.9326 173.147 15.9595C173.147 11.9864 169.923 8.76562 165.946 8.76562C161.969 8.76562 158.745 11.9864 158.745 15.9595C158.745 19.9326 161.969 23.1534 165.946 23.1534Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.233 18.7057C165.071 18.706 164.913 18.6536 164.783 18.5565L164.775 18.5505L163.083 17.2572C162.753 17.0048 162.691 16.5331 162.944 16.2038C163.196 15.8745 163.668 15.8122 163.998 16.0647L165.094 16.9044L167.685 13.5285C167.937 13.1993 168.409 13.1371 168.739 13.3894L168.723 13.4119L168.739 13.3896C169.068 13.6423 169.131 14.1134 168.878 14.4427L165.831 18.4118C165.689 18.5972 165.467 18.7055 165.233 18.7048L165.233 18.7057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.946 71.7862C169.923 71.7862 173.147 68.5654 173.147 64.5923C173.147 60.6192 169.923 57.3984 165.946 57.3984C161.969 57.3984 158.745 60.6192 158.745 64.5923C158.745 68.5654 161.969 71.7862 165.946 71.7862Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.233 67.3385C165.071 67.3388 164.913 67.2864 164.783 67.1893L164.775 67.1833L163.083 65.89C162.753 65.6376 162.691 65.1659 162.944 64.8366C163.196 64.5073 163.668 64.445 163.998 64.6975L165.094 65.5372L167.685 62.1613C167.937 61.8321 168.409 61.7699 168.739 62.0222L168.723 62.0447L168.739 62.0224C169.068 62.2751 169.131 62.7462 168.878 63.0755L165.831 67.0446C165.689 67.23 165.467 67.3383 165.233 67.3376L165.233 67.3385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.031 140.185C183.943 137.932 185.7 136.034 187.955 135.946C188.196 135.937 188.436 135.948 188.675 135.981L195.27 123.055L198.997 129.611L192.163 140.881C191.704 143.101 189.53 144.53 187.307 144.071C185.448 143.688 184.093 142.081 184.031 140.185Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.78 221.585L209.604 221.584L207.142 201.641L214.781 201.641L214.78 221.585Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1 226.591L199.41 226.591V226.38C199.411 222.796 202.319 219.891 205.906 219.891H205.907L216.1 219.891L216.1 226.591Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.838 221.585L237.662 221.584L235.2 201.641L242.839 201.641L242.838 221.585Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.158 226.591L227.469 226.591V226.38C227.469 222.796 230.377 219.891 233.965 219.891H233.965L244.159 219.891L244.158 226.591Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.981 128.93L189.722 132.692C189.722 132.692 193.488 132.692 194.241 138.335L197.253 134.573L191.981 128.93Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.523 121.031C231.523 121.031 237.549 136.832 238.678 146.613C239.808 156.394 241.691 182.352 241.691 182.352L245.457 215.834L234.913 217.339L230.393 183.481L220.226 149.999L217.966 183.481L216.083 213.953L206.292 214.329L205.538 182.728L201.396 142.475L203.656 123.288L231.523 121.031Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.179 73.0703L227.945 75.7033L232.841 124.986L202.337 125.738L206.48 91.504L210.246 81.7228L212.964 78.1327L224.179 73.0703Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.933 108.429L226.085 74.3984C226.085 74.3984 228.322 74.5707 229.075 75.6994C229.829 76.828 242.256 79.0852 242.256 79.0852L239.996 114.072C239.996 114.072 249.411 141.911 246.022 143.416C242.633 144.92 236.607 144.544 236.607 144.544L224.933 108.429Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.668 104.107L210.663 81.1719L201.773 87.178L204.032 103.731L202.149 115.017C202.149 115.017 194.994 146.242 197.253 147.37C199.513 148.499 202.149 147.37 202.149 147.37L206.668 115.769V104.107Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.409 86.4219L201.773 87.1743L200.643 102.222L198.76 115.389L189.722 131.566C189.722 131.566 194.241 128.556 196.124 137.209L206.077 119.897L204.409 86.4219Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.893 137.102C225.244 134.874 227.336 133.353 229.566 133.704C229.804 133.741 230.038 133.8 230.265 133.878L239.247 122.477L241.629 129.631L232.734 139.361C231.853 141.45 229.443 142.43 227.352 141.549C225.602 140.812 224.585 138.974 224.893 137.102Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.185 133.069L236.796 137.208L232.277 129.308L234.159 125.922L240.185 133.069Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.432 80.4032L242.444 78.8984C242.444 78.8984 244.704 81.908 245.08 84.5415C245.457 87.1749 247.34 90.5607 247.34 92.4417C247.34 94.3227 252.612 112.004 252.612 112.004L240.561 136.457C240.561 136.457 237.925 127.428 232.276 126.676L241.691 113.509L236.419 104.104L239.432 80.4032Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.62 226.822H159.711C159.501 226.822 159.331 226.652 159.331 226.442C159.331 226.233 159.501 226.062 159.711 226.062H304.62C304.83 226.062 305 226.233 305 226.442C305 226.652 304.83 226.822 304.62 226.822Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.823 80.5481H0V48.6328H138.823V80.5481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0353 59.1875C19.2882 59.1875 18.6826 59.7925 18.6826 60.5387C18.6826 61.285 19.2882 61.89 20.0353 61.89H118.793C119.54 61.89 120.146 61.285 120.146 60.5387C120.146 59.7925 119.54 59.1875 118.793 59.1875H20.0353Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0354 67.2891C19.2884 67.2875 18.6815 67.8912 18.6799 68.6375C18.6784 69.3837 19.2827 69.99 20.0297 69.9915H82.4655C83.2125 69.9915 83.8182 69.3866 83.8182 68.6403C83.8182 67.894 83.2125 67.2891 82.4655 67.2891L20.0354 67.2891Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.823 80.5481H0V48.6328H138.823V80.5481ZM2.28202 78.2684H136.541V50.9125H2.28202V78.2684Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.823 129.181H0V97.2656H138.823V129.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0353 107.82C19.2882 107.82 18.6826 108.425 18.6826 109.172C18.6826 109.918 19.2882 110.523 20.0353 110.523H118.793C119.54 110.523 120.146 109.918 120.146 109.172C120.146 108.425 119.54 107.82 118.793 107.82H20.0353Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0352 115.922C19.2881 115.92 18.6813 116.524 18.6797 117.27C18.6781 118.017 19.2824 118.623 20.0295 118.624H82.4653C83.2123 118.624 83.8179 118.019 83.8179 117.273C83.8179 116.527 83.2123 115.922 82.4653 115.922H20.0352Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.823 129.181H0V97.2656H138.823V129.181ZM2.28202 126.901H136.541V99.5453H2.28202V126.901Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.964 31.9152H1.14111V0H139.964V31.9152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1763 10.5547C20.4293 10.5561 19.8248 11.1621 19.8262 11.9084C19.8275 12.6527 20.4312 13.2558 21.1763 13.2572H119.934C120.681 13.2558 121.286 12.6497 121.284 11.9035C121.283 11.1591 120.679 10.556 119.934 10.5547H21.1763Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1763 18.6563C20.4293 18.6547 19.8224 19.2584 19.8208 20.0046C19.8192 20.7509 20.4235 21.3572 21.1706 21.3587H83.6064C84.3534 21.3601 84.9601 20.7562 84.9615 20.0099C84.9628 19.2637 84.3584 18.6576 83.6113 18.6563C83.6097 18.6562 83.608 18.6562 83.6064 18.6563L21.1763 18.6563Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.964 31.9152H1.14111V0H139.964V31.9152ZM3.42313 29.6356H137.682V2.27966H3.42313V29.6356Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.163 227.001V199.516C281.163 199.516 291.885 219.001 281.163 227.001Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.825 226.994L261.557 208.406C261.557 208.406 283.178 213.693 281.825 226.994Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 139.356C188.179 139.356 191.404 136.136 191.404 132.163C191.404 128.19 188.179 124.969 184.202 124.969C180.225 124.969 177.001 128.19 177.001 132.163C177.001 136.136 180.225 139.356 184.202 139.356Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.489 134.909C183.327 134.909 183.169 134.857 183.039 134.76L183.031 134.754L181.339 133.46C181.009 133.208 180.947 132.736 181.2 132.407C181.452 132.078 181.925 132.015 182.254 132.268L183.35 133.108L185.941 129.732C186.193 129.402 186.665 129.34 186.995 129.593L186.979 129.615L186.995 129.593C187.325 129.845 187.387 130.317 187.134 130.646L184.088 134.615C183.945 134.8 183.724 134.909 183.489 134.908L183.489 134.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.592 73.689C219.285 73.689 223.9 69.0786 223.9 63.3914C223.9 57.7041 219.285 53.0938 213.592 53.0938C207.899 53.0938 203.284 57.7041 203.284 63.3914C203.284 69.0786 207.899 73.689 213.592 73.689Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.597 71.3035C222.597 71.3035 225.65 65.1266 225.595 62.7684C225.541 60.4102 223.873 54.3419 223.169 53.9417C222.465 53.5416 214.874 49.6913 212.817 50.849C210.759 52.0066 207.139 55.9661 203.234 57.0374C202.129 57.3403 203.094 63.0085 203.094 63.0085L207.663 62.3482C207.663 62.3482 212.427 58.0749 212.633 60.9848C212.839 63.8946 217.257 62.6827 217.257 62.6827L217.312 65.0408L219.12 65.138L219.618 62.6283C219.618 62.6283 220.431 67.7448 219.38 70.406C218.33 73.0671 222.597 71.3035 222.597 71.3035Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_9702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 305,
    height: 227,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicd);
export default __webpack_public_path__ + "static/media/CICD.a794a47291aef060d12d8ea04fa17dbe.svg";
export { ForwardRef as ReactComponent };